/**
 * Device ranges used by useDeviceType with the `breakpoint` decision enabled:
 *
 * - Mobile: below 768px
 * - Tablet: 768px and above when desktop conditions do not match
 * - Desktop: 960px and above with hover and a fine pointer
 *
 * Breakpoints from Sparky's `_breakpoints.scss`:
 *
 * - `$sparky-bp-sm`: 23.4375rem (375px)
 * - `$sparky-bp-sm-2`: 35rem (560px)
 * - `$sparky-bp-md`: 48rem (768px)
 * - `$sparky-bp-lg`: 60rem (960px)
 * - `$sparky-bp-xl`: 75rem (1200px)
 * - `$sparky-bp-xxl`: 87.5rem (1600px)
 */

export const BREAKPOINTS = {
    sm: 375,
    sm2: 560,
    md: 768,
    lg: 960,
    xl: 1200,
    xxl: 1600,
};
